export default __webpack_public_path__ + "static/media/Group-8@2x.eff39101.png";